import React from 'react';
import { FaCar, FaTruck, FaMotorcycle } from 'react-icons/fa';
import '../styles/BackgroundIcons.css';

const BackgroundIcons: React.FC = () => {
  const CarIcon = FaCar as React.ComponentType<{ className?: string; style?: React.CSSProperties }>;
  const TruckIcon = FaTruck as React.ComponentType<{ className?: string; style?: React.CSSProperties }>;
  const MotorcycleIcon = FaMotorcycle as React.ComponentType<{ className?: string; style?: React.CSSProperties }>;

  return (
    <div className="background-icons-container">
      {/* Cars */}
      <div className="background-icon car-icon" style={{ top: '10%', left: '5%' }}>
        <CarIcon />
      </div>

      <div className="background-icon car-icon" style={{ top: '60%', left: '15%' }}>
        <CarIcon />
      </div>

      <div className="background-icon car-icon" style={{ top: '30%', left: '85%' }}>
        <CarIcon />
      </div>

      <div className="background-icon car-icon" style={{ top: '80%', left: '75%' }}>
        <CarIcon />
      </div>

      {/* Trucks */}
      <div className="background-icon truck-icon" style={{ top: '50%', left: '90%' }}>
        <TruckIcon />
      </div>

      <div className="background-icon truck-icon" style={{ top: '20%', left: '12%' }}>
        <TruckIcon />
      </div>

      <div className="background-icon truck-icon" style={{ top: '70%', left: '50%' }}>
        <TruckIcon />
      </div>

      {/* Motorcycles */}
      <div className="background-icon motorcycle-icon" style={{ top: '5%', left: '45%' }}>
        <MotorcycleIcon />
      </div>

      <div className="background-icon motorcycle-icon" style={{ top: '40%', left: '72%' }}>
        <MotorcycleIcon />
      </div>

      <div className="background-icon motorcycle-icon" style={{ top: '90%', left: '25%' }}>
        <MotorcycleIcon />
      </div>

      <div className="background-icon motorcycle-icon" style={{ top: '55%', left: '3%' }}>
        <MotorcycleIcon />
      </div>

      <div className="background-icon car-icon" style={{ top: '15%', left: '60%' }}>
        <CarIcon />
      </div>

      <div className="background-icon truck-icon" style={{ top: '35%', left: '28%' }}>
        <TruckIcon />
      </div>

      <div className="background-icon car-icon" style={{ top: '25%', left: '40%' }}>
        <CarIcon />
      </div>

      <div className="background-icon motorcycle-icon" style={{ top: '75%', left: '65%' }}>
        <MotorcycleIcon />
      </div>

      <div className="background-icon truck-icon" style={{ top: '8%', left: '22%' }}>
        <TruckIcon />
      </div>

      <div className="background-icon car-icon" style={{ top: '45%', left: '8%' }}>
        <CarIcon />
      </div>

      <div className="background-icon motorcycle-icon" style={{ top: '65%', left: '88%' }}>
        <MotorcycleIcon />
      </div>
    </div>
  );
};

export default BackgroundIcons;

